<template>
  <v-app id="inspire">
    <Keyboard />
    <Messages />
    <Drawer />
    <Header versions actions/>
    <SSEAlert />
  
    <v-main :style="`padding: ${mainPadding}`">
      <transition name="fade" mode="out-in">
        <router-view />
      </transition>
    </v-main>
  </v-app>
</template>

<script>
import SSEAlert from '../components/SSEAlert.vue'
import Header from '../components/header'
import Messages from '../components/messages'
import Drawer from '../components/Drawer.vue'
import Keyboard from '../components/keyboard'

export default {
  components:{
    Header,
    Messages,
    Drawer,
    Keyboard,
    SSEAlert
  },
  computed: {
    mini(){
      return this.$vuetify.breakpoint.mdAndDown
    },
    mainPadding() {
      if (this.$vuetify.breakpoint.lgAndUp) {
        return '64px 0 0 256px'
      } else {
      // if (this.$vuetify.breakpoint.smAndDown) {
        return '64px 56px 0 0'
      }

      // return `${this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs ? '56px' : '64px'} 0 0 ${this.mini ? '56px' : '256px'}`
    }
  },
  async mounted(){
    // console.log(this.$vuetify.breakpoint)
    // Load references that used in many views
    await this.$store.dispatch('loadReferences')
  }
}
</script>